<script setup lang="ts">
import { IconBase } from '@solar-icons/vue/lib'

withDefaults(
  defineProps<{
    drawn?: boolean
    /** Draws the check stroke by stroke when `drawn` turns on, instead of showing it at once. */
    animated?: boolean
  }>(),
  { drawn: true, animated: false },
)
</script>

<template>
  <IconBase
    icon-name="drawn-check"
    class="drawn-check shrink-0"
    :data-drawn="drawn ? 'true' : 'false'"
    :data-animated="animated ? 'true' : 'false'"
  >
    <path
      d="M5 12l5 5l10 -10"
      pathLength="1"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </IconBase>
</template>
